import styled from 'styled-components'

export default styled.h1`
  color: ${({ theme }) => theme.colors.headers};
  font-size: 3em;
  line-height: 1.5;
  font-weight: 500;
  margin-top: 0.4em;
`
